import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a9ry3a7qtm: FaireBrandEntity = {
  token: "b_a9ry3a7qtm",
  type: "brand",
  name: "Kinderific",
  avatarUrl:
    "https://cdn.faire.com/fastly/b4d649ed713fabfed0d4d537126a95627ca799bb3ae8b71799cc4b2122d54a84.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4c9bd794732bd203be2780fa6d88ed78090577ae166a4b057a5538e4c3964913.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b4d649ed713fabfed0d4d537126a95627ca799bb3ae8b71799cc4b2122d54a84.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4c9bd794732bd203be2780fa6d88ed78090577ae166a4b057a5538e4c3964913.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Kinderific was born on the beaches of Australia and the bustling blocks of Brooklyn —blending a love for the outdoors with a creative, city-smart spirit. We’re a group of educators, designers, moms and dads who share a passion for nurturing children’s curiosity, confidence, and growth. We're grown-ups who never outgrew the joy of play,  designing toys that help kids feel seen, celebrated, and ready for anything.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:15.508Z",
    importedBy: "entity-db-cli",
  },
};
